import { useTranslation } from "react-i18next";
import Link from "next/link";
import { useRouter } from "next/router";
import FilterFillIcon from "remixicon-react/FilterFillIcon";
import { shopFilters } from "./filter";
import cls from "./home-filter.module.scss";

export default function HomeFilter() {
  const { t } = useTranslation();
  const { query } = useRouter();

  const handleFilter = (filterValue: any) => {
    const tempQuery = { ...query };
    const filterKeys = new Set(
      shopFilters.flatMap((shopFilter) => Object.keys(shopFilter.value)),
    );

    Object.keys(tempQuery).forEach((tempKey) => {
      if (filterKeys.has(tempKey)) {
        delete tempQuery[tempKey];
      }
    });

    return {
      ...tempQuery,
      ...filterValue,
    };
  };

  const isShopFilterActive = (filterValue: any) => {
    return Object.keys(filterValue).every(
      (key) => query?.[key] === filterValue[key],
    );
  };

  const isAnyShopFilterActive = shopFilters.some((shopFilter) =>
    isShopFilterActive(shopFilter.value),
  );

  const isActive = (filterValue: any) => {
    return (
      isShopFilterActive(filterValue) ||
      (!isAnyShopFilterActive && filterValue?.near)
    );
  };

  return (
    <div className={cls.container}>
      <div className={cls.wrapper}>
        <div className={cls.filterIcon}>{<FilterFillIcon size={20} />}</div>
        <div className={cls.tabs}>
          {shopFilters.map((shopFilter) => (
            <div key={shopFilter.label} className={cls.tab}>
              <Link
                href={{
                  query: handleFilter(shopFilter.value),
                }}
                className={`${cls.tabButton} ${
                  isActive(shopFilter.value) ? cls.activeTab : ""
                }`}
              >
                {t(shopFilter.label)}
              </Link>
              {isActive(shopFilter.value) && <div className={cls.activeLine} />}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
